import { Component, AfterViewInit, OnDestroy } from '@angular/core';
import { LayoutService } from '../layout.service';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { AppService } from '../../../app.service';
import { SharedModule } from '../../../share/shared.module';
import { RouterOutlet } from '@angular/router';
import { ConfigService } from '../../../share/services/config.service';
import { LayoutFooterComponent } from "../layout-footer/layout-footer.component";

@Component({
  selector: 'app-layout-login',
  templateUrl: './layout-login.component.html',
  styles: [':host { display: block; }', ':host ::ng-deep .layout-loading .sidenav-link { transition: none !important; }'],
  imports: [SharedModule, RouterOutlet, LayoutFooterComponent],
  providers: [NgbDropdownConfig] // add NgbDropdownConfig to the component providers
})
export class LayoutLoginComponent implements AfterViewInit, OnDestroy {
  // Prevent "blink" effect
  public initialized = false;
  isAcceptance = false;

  constructor(
    private appService: AppService,
    private layoutService: LayoutService,
    config: NgbDropdownConfig,
    private configService: ConfigService
  ) {
    config.placement = 'top-left';
    config.autoClose = 'outside'; 
    this.isAcceptance = configService.getEnv('fetrapiEnv') != 'PRO' ? true : false;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.initialized = true;

      this.layoutService.init();
      this.layoutService.update();
      this.layoutService.setAutoUpdate(true);
    });
  }

  ngOnDestroy() {
    setTimeout(() => {
      this.layoutService.destroy();
    });
  }

  closeSidenav() {
    setTimeout(() => {
      this.layoutService.setCollapsed(true);
    });
  }

  currentBg() {
    return `bg-${this.appService.layoutFooterBg}`;
  }
}
